const formatMoney = (text: string | number, currencyType: string) => {
  return `${currencyType}. ${text
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
};

export default formatMoney;
